import '.bl{position:absolute;}.ssr-plugin'
import '.fb{top:0.75rem;}.ssr-plugin'
import '.fc{right:0.75rem;}.ssr-plugin'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import Column from '@app/components/layout/Column'
import { useState } from 'react'
import { Login } from './Login'
import { HorizontalSeparator } from '@app/components/core/separator/HorizontalSeparator'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { match } from 'ts-pattern'
import { SignUp } from './SignUp'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { styled } from 'inlines'
import { AuthTab, authTabs } from './authTabs'
import useMediaQuery from '@app/util/useMediaQuery'
import { ClientOnly } from '@based/sdk'

export const Authentication = ({
  tab = authTabs.login,
  redirectTo,
  onClose,
  verificationTab = null,
}: {
  tab?: AuthTab
  redirectTo?: string
  onClose?: (setUtm?: boolean) => void
  verificationTab?: AuthTab | null
}) => {
  const [_, navigate] = useLocation()
  const isMobile = useMediaQuery()
  const [selectedTab, setSelectedTab] = useState<AuthTab>(tab)
  const [email, setEmail] = useState('')
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.auth

  const isModalVariant = !!onClose

  const setTab = (tab: AuthTab) => {
    if (!isModalVariant) {
      const page = match(tab)
        .with(authTabs.login, () => pages.login)
        .with(authTabs.signUp, () => pages.signup)
        .exhaustive()
      navigate(page, { replace: true })
    }

    setSelectedTab(tab)
  }

  return (
    <ClientOnly>
      <Column
        alignItems="center"
        style={{
          height: '100%',
        }}
      >
        <Column
          alignItems="stretch"
          gap={0}
          style={{
            width: isMobile ? 'auto' : 'var(--max-width-modal)',
            position: 'relative',
          }}
        >
          <TabsGroup
            selectedTab={selectedTab}
            onSelectTab={setTab}
            style={{ alignSelf: 'center' }}
            tabs={[
              { label: translations.signUp, value: authTabs.signUp },
              { label: translations.logIn, value: authTabs.login },
            ]}
          />
          {onClose && (
            <div className="bl fb fc"
            >
              <CloseButton onClick={() => onClose()} />
            </div>
          )}
          <HorizontalSeparator style={{ marginTop: 1 }} />
          <Column
            alignItems="stretch"
            style={{
              padding: `${isModalVariant ? '1.5rem' : '2rem'} 1.25rem 1.5rem`,
              height: '40rem',
            }}
          >
            {match(selectedTab)
              .with(authTabs.login, () => (
                <Login
                  email={email}
                  redirectTo={redirectTo}
                  setEmail={setEmail}
                  onClose={onClose}
                  startFromVerification={verificationTab === authTabs.login}
                />
              ))
              .with(authTabs.signUp, () => (
                <SignUp
                  email={email}
                  redirectTo={redirectTo}
                  setEmail={setEmail}
                  onClose={onClose}
                  startFromVerification={verificationTab === authTabs.signUp}
                />
              ))
              .exhaustive()}
          </Column>
        </Column>
      </Column>
    </ClientOnly>
  )
}
